import { apiService } from '@/shared/services/api/api.service';
import type { DashboardFilters, DashboardMetrics, PayMetrics } from '../types/dashboard.types';

export class DashboardService {
  /**
   * Get dashboard metrics
   */
  static async getDashboardMetrics(filters: DashboardFilters): Promise<{ success: boolean; data: DashboardMetrics }> {
    const params = new URLSearchParams();

    if (filters.dateRange) {
      params.append('dateRange', filters.dateRange);
    }

    if (filters.startDate) {
      params.append('startDate', filters.startDate.toISOString());
    }

    if (filters.endDate) {
      params.append('endDate', filters.endDate.toISOString());
    }

    if (filters.organizationId) {
      params.append('organizationId', filters.organizationId);
    }

    if (filters.agentId) {
      params.append('agentId', filters.agentId);
    }

    if (filters.campaignId) {
      params.append('campaignId', filters.campaignId);
    }

    const response = await apiService.get(`/analytics/dashboard/metrics?${params.toString()}`);
    return response.data;
  }

  /**
   * Get pay metrics
   */
  static async getPayMetrics(filters: DashboardFilters): Promise<{ success: boolean; data: PayMetrics }> {
    const params = new URLSearchParams();

    if (filters.dateRange) {
      params.append('dateRange', filters.dateRange);
    }

    if (filters.startDate) {
      params.append('startDate', filters.startDate.toISOString());
    }

    if (filters.endDate) {
      params.append('endDate', filters.endDate.toISOString());
    }

    if (filters.organizationId) {
      params.append('organizationId', filters.organizationId);
    }

    if (filters.agentId) {
      params.append('agentId', filters.agentId);
    }

    if (filters.campaignId) {
      params.append('campaignId', filters.campaignId);
    }

    const response = await apiService.get(`/analytics/dashboard/pay-metrics?${params.toString()}`);
    return response.data;
  }
}
